import React, { createContext, useContext, useState } from 'react';

// Translations object
const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      menu: "Speisekarte",
      lunch: "Mittagessen",
      bowls: "Bowls",
      about: "Über uns",
      contact: "Kontakt",
      callNow: "Jetzt anrufen",
    },
    // Hero
    hero: {
      tagline: "Crafted with fire. Delivered with pride. Bremen's finest.",
      title: "Willkommen bei",
      subtitle: "Authentische Pizza & Premium Bowls — frisch zubereitet in Bremen Neustadt",
      orderNow: "Jetzt bestellen",
      viewMenu: "Speisekarte",
      callUs: "Anrufen",
      ribbon: "Mittagsangebot Mo–Fr 11–14 Uhr — Jetzt ansehen",
    },
    // USP
    usp: {
      fresh: "Täglich frisch zubereitet",
      delivery: "Lieferung in 30–45 Min",
      halal: "100% Halal zertifiziert",
    },
    // Popup
    popup: {
      title: "Heute bestellen — frisch gemacht für Sie!",
      subtitle: "Kostenlose Lieferung ab €30 | Mo–So 11:00–22:00",
      uberEats: "Uber Eats",
      lieferando: "Lieferando",
      wolt: "Wolt",
      callUs: "Anrufen & Bestellen — Wir liefern!",
      promo: "Mittagsangebot Mo–Fr 11–14 Uhr",
      dontShowAgain: "Nicht mehr zeigen",
    },
    // Mittagessen
    mittagessen: {
      title: "Mittagessen",
      subtitle: "Täglich frisch — Montag bis Freitag, 11:00 bis 14:00 Uhr",
      drinksNote: "Alle Kombis mit Getränk +€2.50",
      viewMenu: "Vollständige Tageskarte",
      badge: "Wöchentlich wechselndes Menü",
      from: "ab",
    },
    // Menu sections
    menu: {
      pizza: {
        title: "Unsere Pizzen",
        subtitle: "100% Halal • Frisch aus dem Steinofen",
        sizes: { klein: "Klein (26cm)", mittel: "Mittel (32cm)", gross: "Groß (40cm)" },
        filters: {
          all: "Alle",
          vegetarisch: "Vegetarisch",
          vegan: "Vegan",
          chicken: "Chicken",
          meeresfrüchte: "Meeresfrüchte",
          rindfleisch: "Rindfleisch",
        },
      },
      bowls: {
        title: "Premium Bowls",
        subtitle: "Frische & gesunde Bowl-Kreationen",
      },
      baguettes: {
        title: "Baguettes & Wraps",
        subtitle: "Knusprig gebacken, frisch belegt",
      },
      burgers: {
        title: "Burger",
        subtitle: "Saftige Burger mit Premium-Zutaten",
        menus: "Burger Menüs",
      },
      pasta: {
        title: "Pasta & Calzone",
        subtitle: "Italienische Klassiker",
      },
      salads: {
        title: "Salate & Schnitzel",
        subtitle: "Frische Salate & knusprige Schnitzel",
      },
      fingerfood: {
        title: "Fingerfood & Snacks",
        subtitle: "Perfekt zum Teilen",
      },
      dressings: {
        title: "Dressings & Saucen",
        subtitle: "Die perfekte Ergänzung",
      },
      drinks: {
        title: "Getränke",
        subtitle: "Erfrischend & kalt",
      },
    },
    // Common
    common: {
      order: "Bestellen",
      from: "ab",
      popular: "Beliebt",
      premium: "Premium",
      vegan: "Vegan",
      vegetarian: "Vegetarisch",
      spicy: "Scharf",
      halal: "Halal",
      menu1: "Menü 1",
      menu2: "Menü 2",
    },
    // About
    about: {
      title: "Über Hanse Pizza",
      subtitle: "Bremens neue Adresse für authentische Küche",
      story: "Hanse Pizza ist Bremens neue Adresse für authentische, handgemachte Küche. Von der perfekten Pizza aus dem Steinofen bis zu frischen Premium Bowls — wir kochen täglich mit Leidenschaft und den besten Zutaten. 100% Halal. Immer frisch. Nie gefroren. Gegründet von Prasanna Kummara — mit dem Ziel, Bremens bestes Liefer- und Mittagsrestaurant zu werden.",
      halal: "Halal zertifiziert",
      fresh: "Frische Zutaten",
      customers: "Zufriedene Kunden",
    },
    // Reviews
    reviews: {
      title: "Was unsere Kunden sagen",
    },
    // Delivery
    delivery: {
      title: "Jetzt bestellen",
      subtitle: "Wählen Sie Ihre bevorzugte Plattform",
      orderNow: "Jetzt bestellen",
      callTitle: "Anrufen & Bestellen — Wir liefern!",
      callBtn: "Jetzt anrufen",
      selfDelivery: "Selbstlieferung verfügbar in Bremen Neustadt",
      minOrder: "Schnelle Lieferung",
      freeDelivery: "Kostenlose Lieferung ab €30",
    },
    // Catering
    catering: {
      title: "Catering & Corporate",
      subtitle: "Täglich frisches Mittagessen für Ihr Team — individuell, pünktlich, halal",
      features: ["Flexible Menüplanung", "Lieferung direkt ins Büro", "Wochen-/Monatsabrechnung", "Min. 5 Personen"],
      reference: "Reliable daily deliveries to medical facilities and offices across the Bremen Neustadt area.",
      cta: "Catering anfragen",
    },
    // Contact
    contact: {
      title: "Kontakt & Standort",
      hours: "Öffnungszeiten",
      hoursMF: "Mo–So: 11:00–22:00",
      hoursSS: "",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      followUs: "Folgen Sie uns",
      followUsSubtitle: "Für wöchentliche Menü-Updates & Angebote",
    },
    // Footer
    footer: {
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      allergens: "Allergeninformationen",
      closing: "Wir freuen uns auf Ihren Besuch — oder Ihre Bestellung.",
    },
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      menu: "Menu",
      lunch: "Lunch Specials",
      bowls: "Bowls",
      about: "About Us",
      contact: "Contact",
      callNow: "Call Now",
    },
    // Hero
    hero: {
      tagline: "Crafted with fire. Delivered with pride. Bremen's finest.",
      title: "Welcome to",
      subtitle: "Authentic Pizza & Premium Bowls — freshly made in Bremen Neustadt",
      orderNow: "Order Now",
      viewMenu: "View Menu",
      callUs: "Call Us",
      ribbon: "Lunch Deal Mon–Fri 11–14h — View now",
    },
    // USP
    usp: {
      fresh: "Freshly prepared daily",
      delivery: "Delivery in 30–45 min",
      halal: "100% Halal certified",
    },
    // Popup
    popup: {
      title: "Order today — freshly made for you!",
      subtitle: "Free delivery from €30 | Mon–Sun 11:00–22:00",
      uberEats: "Uber Eats",
      lieferando: "Lieferando",
      wolt: "Wolt",
      callUs: "Call Us & Order — We Deliver!",
      promo: "Lunch special Mon–Fri 11–14h",
      dontShowAgain: "Don't show again",
    },
    // Mittagessen
    mittagessen: {
      title: "Lunch Specials",
      subtitle: "Fresh daily — Monday to Friday, 11:00 to 14:00",
      drinksNote: "All combos with drink +€2.50",
      viewMenu: "View Full Menu",
      badge: "Weekly changing menu",
      from: "from",
    },
    // Menu sections
    menu: {
      pizza: {
        title: "Our Pizzas",
        subtitle: "31 handcrafted creations from the stone oven",
        sizes: { klein: "Small (26cm)", mittel: "Medium (32cm)", gross: "Large (40cm)" },
        filters: {
          all: "All",
          vegetarisch: "Vegetarian",
          vegan: "Vegan",
          chicken: "Chicken",
          meeresfrüchte: "Seafood",
          rindfleisch: "Beef",
        },
      },
      bowls: {
        title: "Premium Bowls",
        subtitle: "Fresh & healthy bowl creations",
      },
      baguettes: {
        title: "Baguettes & Wraps",
        subtitle: "Crispy baked, freshly topped",
      },
      burgers: {
        title: "Burgers",
        subtitle: "Juicy burgers with premium ingredients",
        menus: "Burger Menus",
      },
      pasta: {
        title: "Pasta & Calzone",
        subtitle: "Italian classics",
      },
      salads: {
        title: "Salads & Schnitzel",
        subtitle: "Fresh salads & crispy schnitzel",
      },
      fingerfood: {
        title: "Fingerfood & Snacks",
        subtitle: "Perfect for sharing",
      },
      dressings: {
        title: "Dressings & Sauces",
        subtitle: "The perfect addition",
      },
      drinks: {
        title: "Drinks",
        subtitle: "Refreshing & cold",
      },
    },
    // Common
    common: {
      order: "Order",
      from: "from",
      popular: "Popular",
      premium: "Premium",
      vegan: "Vegan",
      vegetarian: "Vegetarian",
      spicy: "Spicy",
      halal: "Halal",
      menu1: "Menu 1",
      menu2: "Menu 2",
    },
    // About
    about: {
      title: "About Hanse Pizza",
      subtitle: "Bremen's new address for authentic cuisine",
      story: "Hanse Pizza is Bremen's new address for authentic, handmade cuisine. From the perfect stone-oven pizza to fresh premium bowls — we cook daily with passion and the best ingredients. 100% Halal. Always fresh. Never frozen. Founded by Prasanna Kummara — with the goal of becoming Bremen's best delivery and lunch restaurant.",
      halal: "Halal certified",
      fresh: "Fresh ingredients",
      customers: "Happy customers",
    },
    // Reviews
    reviews: {
      title: "What Our Customers Say",
    },
    // Delivery
    delivery: {
      title: "Order Now",
      subtitle: "Choose your preferred platform",
      orderNow: "Order Now",
      callTitle: "Call Us & Order — We Deliver!",
      callBtn: "Call Now",
      selfDelivery: "Self-delivery available in Bremen Neustadt",
      minOrder: "Fast delivery",
      freeDelivery: "Free delivery from €30",
    },
    // Catering
    catering: {
      title: "Catering & Corporate",
      subtitle: "Fresh daily lunch for your team — individual, punctual, halal",
      features: ["Flexible menu planning", "Delivery directly to office", "Weekly/monthly billing", "Min. 5 persons"],
      reference: "Reliable daily deliveries to medical facilities and offices across the Bremen Neustadt area.",
      cta: "Request Catering",
    },
    // Contact
    contact: {
      title: "Contact & Location",
      hours: "Opening Hours",
      hoursMF: "Mon–Sun: 11:00–22:00",
      hoursSS: "",
      address: "Address",
      phone: "Phone",
      email: "Email",
      followUs: "Follow Us",
      followUsSubtitle: "For weekly menu updates & offers",
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      allergens: "Allergen Information",
      closing: "We look forward to your visit — or your order.",
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('de');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'de' ? 'en' : 'de'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
